module.exports = __webpack_public_path__ + "static/media/tz.206592dc.svg";